import { SettingsItem } from "./SettingsItem";


export enum OptionsItemType {
    /**
     * Label toggle button
     */
    TOGGLE = 0,
    /**
     * Label toggle button
     */
    SLIDER = 1,
    /**
     * Opens popup with additional content
     * Optionally featues a HELP button that opens popup with additional text content
     */
    SELECTOR = 2,
    /**
     * Plain button. 
     * Clicking button opens binary choice popup.
     * No dynamic content / live data (only static localization).
     */
    BUTTON = 3,
}

/**
 * Settings > Options (options is subcat of settings, and has 
 * specific collections, data models and specific items)
 * 
 * Content of the popup opened by @see OptionsItemType.SELECTOR
 * Each content popup also additionally features TITLE and BACK button on top.
 * NOTE: sometimes SELECTOR that might open LIST (ITEMS_TEXT or LIST_THUMBS) might also
 *       open TEXT content using it's HELP button (however then the contentType 
 *       is set to the LIST contene type and it is always assumed, that if HELP prop exists, 
 *       then the HELP button will ALWAYS open a TEXT content)
 */
export enum OptionsItemContentType 
{
    /**
     * dont need to use 'NONE' as array item index, but can be used as enum for comparisons
     */
    NONE = -1,
    /**
     * Plain text
     * - Get localization data from loc file
     */
    TEXT = 0,
    /**
     * List of toggleable Text items
     * - Get localization data from loc file
     */
    ITEMS_TEXT = 1,
    /**
     * List of toggleable Thumbnails
     * Get texture frames for thumbs from data file
     */
    ITEMS_THUMBS = 2,
}

export class OptionsItem
    extends SettingsItem
{
    
}